(function() {
  // Wait for DrawerComponent to be available
  function initQuickViewProductsList() {
    // Check if DrawerComponent is available
    if (typeof DrawerComponent === 'undefined') {
      setTimeout(initQuickViewProductsList, 100);
      return;
    }

    class QuickViewProductsList extends DrawerComponent {
      constructor() {
        super();
        this.productGrid = this.querySelector('.product-list-grid');
      }

      get isLockingNeeded() {
        return false; // We handle scroll locking manually to ensure it works
      }

      get requiresBodyAppended() {
        return true; // Append to body like other drawers
      }

      shouleBeShow() {
        return true; // Always allow showing
      }

      show(activeElement = null, animate = true) {
        // Prevent body scroll without layout shift by preserving scrollbar space
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.classList.add('quick-view-list-open');
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
        
        // Also lock html element
        document.documentElement.style.overflow = 'hidden';
        
        // Call parent show method
        return super.show(activeElement, animate);
      }

      hide() {
        // Call parent hide method first
        const result = super.hide();
        
        // Restore body scroll after transition completes
        const overlay = this.querySelector('.fixed-overlay');
        let restored = false;
        const restoreScroll = () => {
          if (restored) return;
          restored = true;
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
          document.body.classList.remove('quick-view-list-open');
          document.documentElement.style.overflow = '';
        };

        if (overlay) {
          overlay.addEventListener('transitionend', restoreScroll, { once: true });
          overlay.addEventListener('transitioncancel', restoreScroll, { once: true });
        }
        // Safety fallback — transitionend never fires when the overlay had no
        // transition to run, which would leave the page permanently unscrollable.
        setTimeout(restoreScroll, 800);
        
        return result;
      }

      prepareToShow() {
        super.prepareToShow();
        // Always load products fresh from localStorage when drawer opens
        // This ensures we have the latest quantities from custom-box-preview-modal
        this.loadProducts();
        // Update box full state
        this.updateBoxFullState();
      }

      handleAfterShow() {
        super.handleAfterShow();

        // Closed again before the open transition settled — re-applying the
        // lock now would strand it, since hide()'s restore already ran.
        if (!this.open) return;

        // Ensure scroll lock is still applied (in case parent removed it)
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.classList.add('quick-view-list-open');
        document.documentElement.style.overflow = 'hidden';
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
        
        // Dispatch event for analytics or other listeners
        this.dispatchEvent(new CustomEvent('products-list:opened', {
          bubbles: true,
          detail: { modalId: this.id }
        }));

        // Listen for box state changes from other components
        this.setupBoxStateListeners();
      }


      handleAfterHide() {
        super.handleAfterHide();
        // Dispatch event for analytics or other listeners
        this.dispatchEvent(new CustomEvent('products-list:closed', {
          bubbles: true,
          detail: { modalId: this.id }
        }));

        // Remove box state listeners when drawer is closed
        this.removeBoxStateListeners();
      }

      setupBoxStateListeners() {
        // Listen for box state changes from other components
        this.boxStateChangeHandler = (event) => {
          // Just update quantities without full reload to avoid flicker
          this.updateAllQuantityLimits();
          // Update box full state
          this.updateBoxFullState();
        };

        this.customBoxStateChangeHandler = (event) => {
          // Just update quantities without full reload to avoid flicker
          this.updateAllQuantityLimits();
          // Update box full state
          this.updateBoxFullState();
        };

        window.addEventListener('custom-box-state:updated', this.boxStateChangeHandler);
        window.addEventListener('customBoxStateChanged', this.customBoxStateChangeHandler);
        document.addEventListener('custom-box-state:updated', this.boxStateChangeHandler);
      }

      removeBoxStateListeners() {
        if (this.boxStateChangeHandler) {
          window.removeEventListener('custom-box-state:updated', this.boxStateChangeHandler);
          window.removeEventListener('customBoxStateChanged', this.customBoxStateChangeHandler);
          document.removeEventListener('custom-box-state:updated', this.boxStateChangeHandler);
        }
      }

    loadProducts() {
      // Get filter criteria from data attributes
      const tagsString = this.productGrid.dataset.productTags || '';
      const productType = this.productGrid.dataset.productType || '';
      const collectionHandle = this.productGrid.dataset.collectionHandle || '';
      const requiredTags = tagsString ? tagsString.split(',').map(t => t.trim()) : [];

      // If collection handle is provided, fetch from that collection
      if (collectionHandle) {
        this.loadProductsFromCollection(collectionHandle);
        return;
      }

      // Otherwise, get products from localStorage
      let products = [];
      try {
        const stored = localStorage.getItem('wildgrain-products');
        if (stored) {
          products = JSON.parse(stored);

          // Check if products have handle property - if not, clear cache to force reload
          if (products.length > 0 && !products[0].handle) {
            console.warn('Products missing handle property, clearing cache...');
            localStorage.removeItem('wildgrain-products');
            localStorage.removeItem('wildgrain-products-timestamp');
            // Show message that products need to be reloaded
            this.productGrid.innerHTML = `
              <div style="padding: 2rem; text-align: center;">
                <p style="margin-bottom: 1rem;">Loading products...</p>
                <p style="color: #666; font-size: 0.9rem;">Please refresh the page or wait a moment.</p>
              </div>
            `;
            return;
          }

          // Debug: Check first product structure
          if (products.length > 0) {
            console.log('First product from localStorage:', products[0]);
            console.log('Has handle?', !!products[0].handle);
          }
        }
      } catch (e) {
        console.error('Error loading products from localStorage:', e);
      }

      // Filter products by tags and product type only
      // Show ALL matching products, even if they're not in the box (they'll have qty = 0)
      const filteredProducts = products.filter(product => {
        // Exclude products with SKU starting with WGB or WGP
        const variant = product.variants && product.variants[0];
        const sku = variant?.sku || '';
        if (sku.startsWith('WGB') || sku.startsWith('WGP')) {
          return false;
        }

        // Always require CHECKOUT_ADDON tag
        const rawTags = product.tags || [];
        const productTags = Array.isArray(rawTags)
          ? rawTags.map(t => String(t).trim())
          : String(rawTags)
              .split(',')
              .map(t => String(t).trim())
              .filter(Boolean);
        if (!productTags.includes('CHECKOUT_ADDON')) {
          return false;
        }

        // Check product type (only if product has a type defined)
        if (productType && product.product_type && product.product_type !== productType) {
          return false;
        }

        // Check tags (all required tags must be present)
        if (requiredTags.length > 0) {
          const hasAllTags = requiredTags.every(requiredTag => {
            const trimmedRequired = String(requiredTag).trim();
            return productTags.includes(trimmedRequired);
          });
          if (!hasAllTags) {
            return false;
          }
        }

        return true;
      });

      // Render products
      this.renderProducts(filteredProducts);
    }

    loadProductsFromCollection(collectionHandle) {
      try {
        console.log('Loading products from collection handle:', collectionHandle);

        // Fetch collection products directly from Shopify API using the handle
        fetch(`/collections/${collectionHandle}/products.json`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Failed to fetch collection: ${response.status}`);
            }
            return response.json();
          })
          .then(data => {
            const products = data.products || [];
            console.log('Collection products found:', products.length);

            if (products.length === 0) {
              this.productGrid.innerHTML = `
                <div style="padding: 2rem; text-align: center; color: #666;">
                  No products found in this collection.
                </div>
              `;
              return;
            }

            // Transform Shopify product data to match expected format
            const transformedProducts = products.map(product => ({
              id: product.id,
              title: product.title,
              handle: product.handle,
              featured_image: product.featured_image || product.image?.src || (product.images && product.images[0]?.src),
              images: product.images?.map(img => img.src) || [],
              product_type: product.product_type,
              // Normalize tags to an array of trimmed strings
              tags: Array.isArray(product.tags)
                ? product.tags.map(t => String(t).trim())
                : String(product.tags || '')
                    .split(',')
                    .map(t => String(t).trim())
                    .filter(Boolean),
              variants: product.variants?.map(variant => ({
                id: variant.id,
                title: variant.title,
                price: variant.price,
                sku: variant.sku
              })) || []
            }));

            // Filter out products with SKU starting with WGB or WGP
            const filteredProducts = transformedProducts.filter(product => {
              const variant = product.variants && product.variants[0];
              const sku = variant?.sku || '';
              const tags = Array.isArray(product.tags)
                ? product.tags
                : String(product.tags || '')
                    .split(',')
                    .map(t => String(t).trim())
                    .filter(Boolean);
              return !sku.startsWith('WGB') && !sku.startsWith('WGP') && tags.includes('CHECKOUT_ADDON');
            });

            console.log('Filtered products:', filteredProducts.length);

            this.renderProducts(filteredProducts);
          })
          .catch(error => {
            console.error('Error loading products from collection:', error);
            this.productGrid.innerHTML = `
              <div style="padding: 2rem; text-align: center; color: #666;">
                Error loading products. Please try again.
              </div>
            `;
          });
      } catch (error) {
        console.error('Error loading products from collection:', error);
        this.productGrid.innerHTML = `
          <div style="padding: 2rem; text-align: center; color: #666;">
            Error loading products. Please try again.
          </div>
        `;
      }
    }

    renderProducts(products) {
      if (products.length === 0) {
        this.productGrid.innerHTML = `
          <div style="padding: 2rem; text-align: center; color: #666;">
            No products found matching the selected criteria.
          </div>
        `;
        return;
      }

      const boxState = this.getBoxState();

      const productsHtml = products.map(product => {
        const variant = product.variants && product.variants[0];
        const variantId = variant ? variant.id : '';
        const imageUrl = product.featured_image || product.image || (product.images && product.images[0]) || '';

        // Get price and quantity
        const price = variant?.price || product.price || 0;
        const currentQuantity = boxState?.productQuantities?.[product.id] || 0;

        // Resize image to 200x200 (matching custom-box-preview-modal.js)
        const resizedImage = this.getResizedImageUrl(imageUrl, '200x200');

        // Check if box is full
        const totalItems = Object.values(boxState?.productQuantities || {}).reduce((sum, qty) => sum + qty, 0);
        const boxSize = this.getBoxSize(boxState?.selectedSize);
        const isBoxFull = boxState?.boxFull === true || totalItems >= boxSize;

        // Build product URL - try multiple possible property names
        let productUrl = product.url;
        if (!productUrl && product.handle) {
          productUrl = `/products/${product.handle}`;
        }
        if (!productUrl && product.product_handle) {
          productUrl = `/products/${product.product_handle}`;
        }
        if (!productUrl && product.slug) {
          productUrl = `/products/${product.slug}`;
        }

        // Debug: log if we can't find a URL
        if (!productUrl) {
          console.warn('Product missing URL/handle:', product.id, product.title, Object.keys(product));
        }

        return `
          <div class="cart-item flex flex-col gap-4 ${currentQuantity > 0 ? 'has-quantity' : ''}" data-product-id="${product.id}">
            <div class="cart-item__product flex items-start gap-3">
              ${resizedImage && productUrl ? `
                <a href="${productUrl}"
                   class="cart-item__media blocks-radius-sm media-wrapper"
                   data-product-url="${productUrl}"
                   data-quickview-trigger
                   style="cursor: pointer;">
                  <img src="${resizedImage}" alt="${this.escapeHtml(product.title)}" loading="lazy">
                </a>
              ` : resizedImage ? `
                <div class="cart-item__media blocks-radius-sm media-wrapper">
                  <img src="${resizedImage}" alt="${this.escapeHtml(product.title)}" loading="lazy">
                </div>
              ` : ''}
              <div class="cart-item__details flex-grow flex flex-col gap-2">
                <div class="grid">
                  <div class="block">
                    ${productUrl ? `
                      <a href="${productUrl}"
                         data-product-url="${productUrl}"
                         data-quickview-trigger
                         style="cursor: pointer; text-decoration: none; color: inherit;">
                        <span class="cart-item__title text-pcard-title">${this.escapeHtml(product.title)}</span>
                      </a>
                    ` : `
                      <span class="cart-item__title text-pcard-title">${this.escapeHtml(product.title)}</span>
                    `}
                  </div>
                </div>
              </div>
              <div class="cart-item__action flex flex-col items-end justify-end gap-4">
                <div class="flex items-center gap-2">
                  <div class="cart-quantity quantity">
                    <button type="button" name="minus" class="quantity__button" data-action="decrease" data-product-id="${product.id}" aria-label="Decrease quantity">
                      <svg width="16" height="16" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.6875 7H12.3125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                    <input class="quantity__input" type="number" value="${currentQuantity}" readonly style="pointer-events: none;" data-product-id="${product.id}">
                    <button type="button" name="plus" class="quantity__button ${isBoxFull ? 'disabled' : ''}" data-action="increase" data-product-id="${product.id}" aria-label="Increase quantity" ${isBoxFull ? 'disabled style="opacity: 0.5; cursor: not-allowed;"' : ''}>
                      <svg width="16" height="16" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.6875 7H12.3125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.5 2.1875V11.8125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
      }).join('');

      this.productGrid.innerHTML = productsHtml;

      // Initialize quantity inputs with current box state
      setTimeout(() => {
        this.attachQuantityListeners();
        this.updateAllQuantityLimits();
        this.updateBoxFullState();
      }, 100);
    }

    attachQuantityListeners() {
      // Use event delegation to avoid duplicate listeners
      // Only attach once - the listener will handle all current and future buttons
      if (this._quantityListenerAttached) {
        return;
      }

      this.productGrid.addEventListener('click', (e) => {
        // Handle quantity buttons
        const actionButton = e.target.closest('[data-action]');
        if (actionButton) {
          e.preventDefault();
          e.stopPropagation();
          const action = actionButton.dataset.action;
          const productId = actionButton.dataset.productId;

          if (action === 'increase' || action === 'decrease') {
            this.handleQuantityChange(productId, action);
          }
          return;
        }

        // Handle quick view triggers
        const quickviewTrigger = e.target.closest('[data-quickview-trigger]');
        if (quickviewTrigger) {
          e.preventDefault();
          const productUrl = quickviewTrigger.dataset.productUrl;
          if (productUrl) {
            this.openQuickView(productUrl);
          }
          return;
        }
      });

      this._quantityListenerAttached = true;
    }

    openQuickView(productUrl) {
      // Validate product URL
      if (!productUrl || productUrl === 'null' || productUrl === 'undefined') {
        console.error('Invalid product URL:', productUrl);
        return;
      }

      // Find the quick-view modal in the DOM
      let modal = document.querySelector('quick-view-modal');

      if (!modal) {
        console.error('Quick view modal not found, navigating to product page');
        window.location.href = productUrl;
        return;
      }

      // Set the product URL
      modal.setAttribute('data-product-url', productUrl);

      // Show the quick view modal
      if (typeof modal.show === 'function') {
        modal.show();
      } else {
        modal.removeAttribute('hidden');
      }
    }

    // Dispatch quantity change request - let custom-box-preview-modal handle the actual state change
    handleQuantityChange(productId, action) {
      try {
        // Check if box is full before allowing increase
        if (action === 'increase') {
          const boxState = this.getBoxState();
          if (boxState?.boxFull === true) {
            return;
          }

          const totalItems = Object.values(boxState?.productQuantities || {}).reduce((sum, qty) => sum + qty, 0);
          const boxSize = this.getBoxSize(boxState?.selectedSize);

          if (totalItems >= boxSize) {
            // Close drawer if box is already full
            this.hide();
            return;
          }
        }

        // Dispatch event for custom-box-preview-modal to handle
        window.dispatchEvent(new CustomEvent('custom-box:quantity-change-request', {
          detail: { productId, action }
        }));

        // Check if box became full after the change and close drawer
        setTimeout(() => {
          const boxState = this.getBoxState();
          if (boxState?.boxFull === true) {
            this.hide();
          }
        }, 50);
      } catch (error) {
        console.error('Error dispatching quantity change:', error);
      }
    }

    getBoxState() {
      const STORAGE_KEY = 'wildgrain-custom-box-state';
      try {
        const state = localStorage.getItem(STORAGE_KEY);
        return state ? JSON.parse(state) : null;
      } catch (e) {
        console.error('Error parsing custom box state:', e);
        return null;
      }
    }


    getTotalBoxItems(productQuantities) {
      return Object.values(productQuantities || {}).reduce((sum, qty) => sum + qty, 0);
    }

    getBoxSize(selectedSize) {
      const match = selectedSize ? selectedSize.match(/(\d+)/) : null;
      return match ? parseInt(match[1]) : 0;
    }

    getResizedImageUrl(imageUrl, size = '200x200') {
      if (!imageUrl) return null;

      // Shopify image URL format: add size parameter before file extension
      // Use crop_center to ensure square images
      // Example: image.jpg -> image_200x200_crop_center.jpg
      const extensionIndex = imageUrl.lastIndexOf('.');
      if (extensionIndex === -1) return imageUrl;

      // Check if already has size parameter
      if (imageUrl.includes('_' + size + '_crop_center')) return imageUrl;
      if (imageUrl.includes('_crop_center')) return imageUrl;

      return imageUrl.substring(0, extensionIndex) + '_' + size + '_crop_center' + imageUrl.substring(extensionIndex);
    }


    getRemainingSpace(boxState) {
      if (!boxState || !boxState.selectedSize) {
        return 0;
      }

      const totalItems = this.getTotalBoxItems(boxState.productQuantities);
      const boxSize = this.getBoxSize(boxState.selectedSize);
      return Math.max(0, boxSize - totalItems);
    }


    updateQuantityLimits(quantityInput, productId, boxState) {
      if (!quantityInput) return;

      const currentQtyInBox = boxState?.productQuantities?.[productId] || 0;
      const remainingSpace = this.getRemainingSpace(boxState);
      const totalItems = this.getTotalBoxItems(boxState?.productQuantities);
      const boxSize = this.getBoxSize(boxState?.selectedSize);
      const isAvailable = boxState?.availableProducts?.includes(parseInt(productId));
      const isBoxFull = boxState?.boxFull === true || totalItems >= boxSize;

      // Find the parent quantity container and increase button
      const quantityContainer = quantityInput.closest('.quantity');
      const increaseButton = quantityContainer?.querySelector('[data-action="increase"]');

      // Disable/enable increase button based on box state
      if (increaseButton) {
        if (isBoxFull) {
          increaseButton.disabled = true;
          increaseButton.style.opacity = '0.5';
          increaseButton.style.cursor = 'not-allowed';
        } else {
          increaseButton.disabled = false;
          increaseButton.style.opacity = '1';
          increaseButton.style.cursor = 'pointer';
        }
      }

      // Update custom box status text
      const statusContainer = quantityInput.closest('.product-form__quantity')?.querySelector('.custom-box-status');
      const statusText = statusContainer?.querySelector('.custom-box-status-text');
      if (statusContainer && statusText) {
        if (isAvailable && remainingSpace === 0 && totalItems >= boxSize) {
          // Box is full
          statusText.textContent = 'Box Full';
          statusContainer.style.display = 'block';
          statusContainer.style.background = '#fee2e2';
          statusContainer.style.color = '#991b1b';
        } else if (isAvailable && remainingSpace > 0) {
          // Show remaining space
          statusText.textContent = `${remainingSpace} space${remainingSpace !== 1 ? 's' : ''} remaining in box`;
          statusContainer.style.display = 'block';
          statusContainer.style.background = '#f0f9ff';
          statusContainer.style.color = '#0c4a6e';
        } else {
          // Not available for custom box or no box state
          statusContainer.style.display = 'none';
        }
      }
    }

    updateAllQuantityLimits() {
      const boxState = this.getBoxState();
      if (!boxState) return;

      this.productGrid.querySelectorAll('.quantity__input').forEach(quantityInput => {
        const productId = quantityInput.dataset.productId;
        if (!productId) return;

        // Update the input value from box state
        const storedQty = boxState?.productQuantities?.[productId] || 0;
        quantityInput.value = storedQty;

        // Update the has-quantity class on the cart-item
        const cartItem = quantityInput.closest('.cart-item');
        if (cartItem) {
          if (storedQty > 0) {
            cartItem.classList.add('has-quantity');
          } else {
            cartItem.classList.remove('has-quantity');
          }
        }

        // Update quantity limits and status
        this.updateQuantityLimits(quantityInput, productId, boxState);
      });
    }

    updateBoxFullState() {
      const boxState = this.getBoxState();
      if (!boxState) {
        this.classList.remove('box-full');
        return;
      }

      const totalItems = Object.values(boxState?.productQuantities || {}).reduce((sum, qty) => sum + qty, 0);
      const boxSize = this.getBoxSize(boxState?.selectedSize);
      const isBoxFull = boxState?.boxFull === true || totalItems >= boxSize;

      if (isBoxFull) {
        this.classList.add('box-full');
      } else {
        this.classList.remove('box-full');
      }
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }

    if (!customElements.get('quick-view-products-list')) {
      customElements.define('quick-view-products-list', QuickViewProductsList);
    }
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickViewProductsList);
  } else {
    initQuickViewProductsList();
  }
})();
